import { render } from "./AddIntercom.vue?vue&type=template&id=d936f422&scoped=true"
import script from "./AddIntercom.vue?vue&type=script&lang=js"
export * from "./AddIntercom.vue?vue&type=script&lang=js"

import "./AddIntercom.vue?vue&type=style&index=0&id=d936f422&lang=scss&scoped=true"

import exportComponent from "/home/prof1/projects/intercom_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d936f422"]])

export default __exports__